module.exports = __webpack_public_path__ + "img/save_3.cb8fe202.png";